import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle, Input } from 'reactstrap';
import { useHistory, useLocation, useParams } from 'react-router';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify'
import { DateTime } from 'luxon';
import bootbox from 'bootbox'

import { appendModel, deleteSite, modifyModelAttr } from '../../../../features/site/siteSlice'
import { BUSINESS_CATEGORIES, getImageSpecs, serviceMap, setInitialScanSite, toBase64 } from '../../../utils/common';
import { updateSite, addSite, deleteSiteById } from '../../../utils/Organizations';

import SidePanelToggle from '../../Layout/Common/SidePanelToggle';
import ConsumerSources from '../ConsumerSources';
import BudgetsAndThresholds from '../BudgetsAndThresholds';
import BaseService from '../ServiceTypes/Base'
import ServiceCard from '../ServiceTypes/ServiceCard';
import SiteUsers from '../UserTypes/SiteUsers';
import { getStartupProgress } from '../../../../features/session/sessionSlice';
import { getUsers } from '../../../utils/Users';
import FranchescaAssessments from '../Franchesca/FranchescaAssessments';

const INITIAL_STATE = {
    chosenService: serviceMap.ga,
    servicePanel: false,
    userServicePanel: false,
    refServicePanel: false,
    disableButtons: false,
    searchTerm: "",
    optionsDropdownOpen: false,
    refBudgetPanel: false,
    refFranchescaAssessmentPanel: false
}

function SiteModification(props){
    const dispatch = useDispatch()
    const history = useHistory()
    const { type } = useParams();

    const [freeTrialActive, setFreeTrialActive] = useState(false)
    const [state, setState] = useState(INITIAL_STATE)

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)
    const trialMode = useSelector(state => state.session.trialMode)

    useEffect(() => {
        if(state.userServicePanel){
            getUsers(model.siteForm.siteId).then(({response, error}) => {
                if(response){
                    dispatch(appendModel({
                        users: response.users || []
                    }))
                } else {
                    dispatch(appendModel({
                        users: []
                    }))
                }
            })
        }
    }, [state.userServicePanel])

    const onChange = (property="attr", bool=false) => (e) => {
        let modelCopy = {siteForm:{...model.siteForm}}

        if(property){
            modelCopy.siteForm[property] = {
                ...modelCopy.siteForm[property],
                [e.target.name]: bool ? !modelCopy.siteForm[property][e.target.name] : e.target.value
            }
        } else {
            modelCopy.siteForm[e.target.name] = bool ? !modelCopy.siteForm[e.target.name] : e.target.value
        }

        dispatch(modifyModelAttr({
            key: "siteForm",
            body: modelCopy.siteForm
        }))
    }

    const roiOnChange = (e) => {
        let modelCopy = {siteForm:{...model.siteForm}}

        modelCopy.siteForm.attr = {
            ...modelCopy.siteForm.attr,
            roi: {
                ...modelCopy.siteForm.attr.roi,
                [e.target.name]: e.target.value
            }
        }

        dispatch(appendModel(modelCopy))
    }

    const viewService = (service) => {
        if(service === "assessments"){
            setState(prev => ({
                ...prev,
                refFranchescaAssessmentPanel: true
            }))
        } else {
            setState(prev => ({
                ...prev,
                chosenService: service,
                servicePanel: true
            }))
        }
    }

    const saveSite = async(suspended = false) => {
        await setState(prev => ({
            ...prev,
            disableButtons: true
        }))
        if(model.siteForm?.siteId) {

            await updateSite(model.siteForm?.siteId, null, {
                site: {
                    ...model.siteForm,
                    attr: {
                        ...(model.siteForm?.attr ?? {}),
                        trialExpiryDate: !freeTrialActive ? undefined : model.siteForm?.attr.trialExpiryDate,
                        suspended 
                    }
                }
            })

            let all = [...model.all]

            const allIdx = all.findIndex(a => a.siteId === model.siteForm.siteId)

            if(allIdx){
                all[allIdx] = {
                    ...model.siteForm,
                    attr: {
                        ...(model.siteForm?.attr ?? {}),
                        trialExpiryDate: !freeTrialActive ? undefined : model.siteForm?.attr.trialExpiryDate,
                        suspended 
                    }
                }
            }

            let sites = [...model.sites]

            sites[model.siteActiveIdx] = {
                ...model.siteForm,
                attr: {
                    ...(model.siteForm?.attr ?? {}),
                    trialExpiryDate: !freeTrialActive ? undefined : model.siteForm?.attr.trialExpiryDate,
                    suspended 
                }
            }

            dispatch(appendModel({
                sites,
                all
            }))

            toast.success("Update successful", {containerId: "defaultToastContainer"})

            if(trialMode){
                dispatch(getStartupProgress())
            }
        } else {
            let sForm = {
                ...model.siteForm
            }

            sForm.sitePath = model?.regions[model?.regActiveIdx].sitePath
            
            const {response, error} = await addSite(null, {
                site: sForm
            })
            
            sForm.siteId = response.siteId
            sForm.sitePath += '/'+sForm.siteId

            dispatch(appendModel({
                sites: [...model.sites, {...sForm}],
                all: [...model.all, {...sForm}],
                siteForm: sForm,
                siteActiveIdx: model.sites.length
            }))
            
            toast.success("Site has been created successfully", {containerId: "defaultToastContainer"})
        }
        await setState(prev => ({
            ...prev,
            disableButtons: false
        }))

    }

    const onDelete = async() => {
        bootbox.confirm({
            title: `Confirmation`,
            size: "small",
            message: `Are you sure you want to delete ${model.siteForm.name}?`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> No'
                },
                confirm: {
                    className: 'btn-danger',
                    label: '<i class="fa fa-check"></i> Yes'
                }
            },
            callback: async function (result) {
                if(result){

                    const {response, error } = await deleteSiteById(model?.siteForm?.siteId)
                    
                    if(response){
                        toast.success("Site has been deleted", {containerId: "defaultToastContainer"})
                        await dispatch(deleteSite({
                            siteId: model?.siteForm?.siteId, 
                            siteType: "SITE"
                        }))

                        await props.onDeleteSite(model?.siteForm?.siteId, "SITE")
                    }
                }
            }
        });

    }


    const addSearchTerm = () => {
        let modelCopy = {siteForm: {...model.siteForm}}

        if(modelCopy.siteForm.attr?.searchTerms && modelCopy.siteForm.attr?.searchTerms.length >= 10){
            toast.error("A site can only have up to 10 search terms", {containerId: "defaultToastContainer"})
            return
        }
        modelCopy.siteForm = {
            ...modelCopy.siteForm,
            attr: {
                ...modelCopy.siteForm.attr,
                searchTerms: [
                    ...(modelCopy.siteForm.attr?.searchTerms ?? []),
                    state.searchTerm
                ]
            }
        }
        dispatch(modifyModelAttr({
            key: "siteForm",
            body: modelCopy.siteForm
        }))

        setState(prev => ({
            ...prev,
            searchTerm: INITIAL_STATE.searchTerm
        }))

    }

    const removeSearchTerm = (key) => {
        let modelCopy = {siteForm: {...model.siteForm}}
        modelCopy.siteForm = {
            ...modelCopy.siteForm,
            attr: {
                ...modelCopy.siteForm.attr,
                searchTerms: [...modelCopy.siteForm.attr.searchTerms.filter((_, k) => k !== key)]
            }
        }

        dispatch(modifyModelAttr({
            key: "siteForm",
            body: modelCopy.siteForm
        }))
    }

    const onImageChange = async(e) => {
        const { height, width } = await getImageSpecs(e.target.files[0])

        if(height !== width){
            toast.error("Image width and height must be the same number of pixels", {containerId: "defaultToastContainer"})
        } else if(height > 50 || width > 50){
            toast.error("Image width and height must be the less than or equal to 50 pixels", {containerId: "defaultToastContainer"})
        }  else {
            const crmImg = await toBase64(e.target.files[0])
    
            let modelCopy = {
                siteForm: {
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        crmImg
                    }
                }
            }
    
            dispatch(modifyModelAttr({
                key: "siteForm",
                body: modelCopy.siteForm
            }))
        }
    }

    useEffect(() => {
        if(props?.serviceType){
            viewService(serviceMap[props?.serviceType] ?? props?.serviceType)
        }
    }, [])

    useEffect(() => {
        if(model.siteForm?.attr?.trialExpiryDate){
            setFreeTrialActive(true)
        } else {
            setFreeTrialActive(false)
        }
    }, [model.siteForm?.attr?.trialExpiryDate])

    useEffect(() => {
        if(freeTrialActive && !model.siteForm?.attr?.trialExpiryDate){
            let modelCopy = {siteForm:{...model.siteForm}}

            modelCopy.siteForm = {
                ...model.siteForm,
                attr: {
                    ...modelCopy.siteForm.attr,
                    trialExpiryDate: DateTime.local().plus({days: 7}).toISODate()
                }
            }

            dispatch(appendModel(modelCopy))
        }
    }, [freeTrialActive])

    const { siteForm, sites, siteActiveIdx } = model

    const { disableButtons, optionsDropdownOpen } = state

    const inputDisabled = model.reseller && model.isAffiliate ? true : false

    const site = sites ? sites[siteActiveIdx] : {}

    return <>
        <div class="card card-raised h-100">
            <div class="card-body p-20">
                <div className="d-flex justify-content-between align-items-center">
                    <div class={`overline mb-4 text-${siteForm?.attr?.status === "evaluation" && (isAdmin || model.reseller) ? "white badge badge-danger" : "muted"}`}>
                        {siteForm?.attr?.status === "evaluation" && (isAdmin || model.reseller) ? "Initial Scan " : ""}Site
                    </div>
                    <div>
                        {isAdmin && <div className="btn-group mr-2 d-none d-sm-none d-md-none d-lg-inline-flex d-xl-inline-flex">
                            {siteForm?.attr?.suspended ? <button className="btn btn-lg btn-outline-success" disabled={disableButtons} onClick={() => saveSite(false)}>
                                <i class="fas fa-play-circle"></i> Activate
                            </button> : <button className="btn btn-lg btn-danger" disabled={disableButtons} onClick={() => saveSite(true)}>
                                <i class="fas fa-stop-circle"></i> Suspend
                            </button>}
                        </div>}
                        {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className="btn-group mr-2 d-none d-sm-none d-md-none d-lg-inline-flex d-xl-inline-flex">
                            <button className="btn btn-lg btn-primary" disabled={disableButtons} onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {!model.orgFixed && siteForm?.siteId && <button className="btn btn-lg btn-outline-danger" id="siteDeleteBtn" disabled={disableButtons} onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                        </div>}
                        <div className="btn-group mr-2 d-none d-sm-none d-md-none d-lg-inline-flex d-xl-inline-flex">
                            {siteForm?.siteId && <button id="siteUsersBtn" className="btn btn-lg btn-outline-info" disabled={disableButtons} onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                            {siteForm?.siteId && !trialMode && <div class="btn-group">
                                <button type="button" class="btn btn-warning dropdown-toggle btn-lg" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Options
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:;" onClick={e => setState(prev => ({...prev, refServicePanel: true}))}>Referrals</a>
                                    <a class="dropdown-item" href="javascript:;" onClick={e => setState(prev => ({...prev, refBudgetPanel: true}))}>Budgets and Thresholds</a>
                                    {(isAdmin) && <a class="dropdown-item" href="javascript:;" onClick={e => setState(prev => ({...prev, refFranchescaAssessmentPanel: true}))}>
                                        Franchesca Assessments
                                    </a>}
                                    {(isAdmin) && <a class="dropdown-item" href="javascript:;" onClick={e => {
                                        setInitialScanSite(siteForm?.sitePath)
                                        history.push("/initial-scan")
                                    }}>
                                        View Initial Scan
                                    </a>}
                                </div>
                            </div>}
                        </div>

                        <div className="btn-group mr-2 d-inline-flex d-sm-inline-flex d-md-inline-flex d-lg-none d-xl-none">
                            <button className="btn btn-outline-primary" onClick={() => props.onGoBack()}>
                                <i class="fas fa-chevron-circle-left"></i> Back
                            </button>
                            {isAdmin && (siteForm?.attr?.suspended ? <button className="btn btn-outline-success" disabled={disableButtons} onClick={() => saveSite(false)}>
                                <i class="fas fa-play-circle"></i> Activate
                            </button> : <button className="btn btn-danger" disabled={disableButtons} onClick={() => saveSite(true)}>
                                <i class="fas fa-stop-circle"></i> Suspend
                            </button>)}
                            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <><button className="btn btn-primary" disabled={disableButtons} onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {!model.orgFixed && siteForm?.siteId && <button className="btn btn-outline-danger" id="siteDeleteBtn" disabled={disableButtons} onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}</>}
                        </div>
                        <div className="btn-group mr-2 d-inline-flex d-sm-inline-flex d-md-inline-flex d-lg-none d-xl-none">
                            {siteForm?.siteId && <button className="btn btn-outline-info" disabled={disableButtons} onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                            {siteForm?.siteId && !trialMode && <div class="btn-group">
                                <button type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Options
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="javascript:;" onClick={e => setState(prev => ({...prev, refServicePanel: true}))}>Referrals</a>
                                    <a class="dropdown-item" href="javascript:;" onClick={e => setState(prev => ({...prev, refBudgetPanel: true}))}>Budgets and Thresholds</a>
                                    {(isAdmin) && <a class="dropdown-item" href="javascript:;" onClick={e => setState(prev => ({...prev, refFranchescaAssessmentPanel: true}))}>
                                        Franchesca Assessments
                                    </a>}
                                    {(isAdmin) && <a class="dropdown-item" href="javascript:;" onClick={e => history.push("/initial-scan")}>
                                        View Initial Scan
                                    </a>}
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
                <h1 className="d-none d-sm-none d-md-none d-lg-block d-xl-block">{siteForm?.name}</h1>
                <h2 className="d-block d-sm-block d-md-block d-lg-none d-xl-none">{siteForm?.name}</h2>
                <form>
                    <div className="form-row">
                        <div class="form-group col-lg-4">
                            <label class="col-form-label" for="fullname">Site Name:</label>
                            <input type="text" class="form-control" name="name" value={siteForm?.name} onChange={onChange(null)} disabled={inputDisabled} />
                        </div>
                        <div class="form-group col-lg-4">
                            <label class="col-form-label" for="fullname">Site URL:</label>
                            <input type="text" class="form-control" name="url" value={siteForm?.attr?.url} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                        <div class="form-group col-lg-4">
                            <label class="col-form-label" for="fullname">Timezone:</label>
                            <select class="form-control" name="tz" value={siteForm?.attr?.tz} onChange={onChange()} disabled={inputDisabled}>
                                <option value="Samoa">Samoa</option>
                                <option value="Hawaii-Aleutian">Hawaii-Aleutian</option>
                                <option value="Alaska">Alaska</option>
                                <option value="Pacific">Pacific</option>
                                <option value="Mountain">Mountain</option>
                                <option value="Central">Central</option>
                                <option value="Eastern">Eastern</option>
                                <option value="Atlantic">Atlantic</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-row">
                        <div class="form-group col-lg-3">
                            <label class="col-form-label" for="address">Address:</label>
                            <input type="text" class="form-control" name="address" value={siteForm?.attr?.address} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                        <div class="form-group col-lg-3">
                            <label class="col-form-label" for="city">City:</label>
                            <input type="text" class="form-control" name="city" value={siteForm?.attr?.city} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                        <div class="form-group col-lg-3">
                            <label class="col-form-label" for="state">State:</label>                           
                            <select class="form-control" name="state" value={siteForm?.attr?.state} onChange={onChange()} disabled={inputDisabled}>
                                <option value=""></option>
                                <option value="AL">Alabama</option>
                                <option value="AK">Alaska</option>
                                <option value="AZ">Arizona</option>
                                <option value="AR">Arkansas</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DE">Delaware</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="HI">Hawaii</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="IA">Iowa</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="ME">Maine</option>
                                <option value="MD">Maryland</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MS">Mississippi</option>
                                <option value="MO">Missouri</option>
                                <option value="MT">Montana</option>
                                <option value="NE">Nebraska</option>
                                <option value="NV">Nevada</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NY">Ney York</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dekota</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dekota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VT">Vermont</option>
                                <option value="VA">Virginia</option>
                                <option value="WA">Washington</option>
                                <option value="WV">West Virginia</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WY">Wyoming</option>
                            </select>
                        </div>
                        <div class="form-group col-lg-3">
                            <label class="col-form-label" for="zip">Zip:</label>
                            <input type="text" class="form-control" name="zip" value={siteForm?.attr?.zip} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div className="form-row">
                        <div class="form-group col-lg-3">
                            <label class="col-form-label" for="businessPhone">Business Phone:</label>
                            <InputMask 
                                className="form-control"
                                mask="(999) 999-9999"
                                name="businessPhone" 
                                maskChar={null}
                                value={siteForm?.attr?.businessPhone} 
                                disabled={inputDisabled}
                                onChange={onChange()} />
                        </div>
                        <div class="form-group col-lg-3">
                            <label class="col-form-label" for="cellPhone">Cell Phone:</label>
                            <InputMask 
                                className="form-control"
                                mask="(999) 999-9999"
                                name="cellPhone" 
                                maskChar={null}
                                value={siteForm?.attr?.cellPhone} 
                                disabled={inputDisabled}
                                onChange={onChange()} />
                        </div>
                        {isAdmin && <div class="form-group col-lg-3">
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="toggleFreeTrial" checked={freeTrialActive ? "checked": ""} onChange={e => setFreeTrialActive(!freeTrialActive)} disabled={inputDisabled} />
                                <label class="form-check-label" for="toggleFreeTrial">Free Trial:</label>
                            </div>
                            {freeTrialActive && <input type="date" class="form-control mt-2" pattern="\d{4}-\d{2}-\d{2}" name="trialExpiryDate" onChange={onChange('attr', false)} value={siteForm?.attr.trialExpiryDate} disabled={inputDisabled} />}
                        </div>}
                        <div class="form-group col-lg-3 align-items-center justify-content-center d-none d-sm-none d-md-none d-lg-flex d-xl-flex">     
                            <div>                       
                                {(isAdmin || (model.reseller && !model.isAffiliate)) && <div className="form-check">
                                    <input type="checkbox" class="form-check-input" name="isFranchise" id="franchise" checked={siteForm?.attr?.isFranchise ? "checked": ""} onChange={onChange('attr', true)} disabled={inputDisabled} />
                                    <label class="form-check-label" htmlFor="franchise">Franchise?</label>
                                </div>}
                                {isAdmin && <div className="form-check">
                                    <input type="checkbox" class="form-check-input" name="isEcommerce" id="ecom" checked={siteForm?.attr?.isEcommerce ? "checked": ""} onChange={onChange('attr', true)} disabled={inputDisabled} />
                                    <label class="form-check-label" htmlFor="ecom">Ecommerce?</label>
                                </div>}
                            </div>
                        </div>
                        <div class="form-group col-sm-12 d-flex align-items-center d-md-flex d-lg-none d-xl-none">     
                            {(isAdmin || (model.reseller && !model.isAffiliate)) && <div className="form-check">
                                <input type="checkbox" class="form-check-input" name="isFranchise" id="franchise" checked={siteForm?.attr?.isFranchise ? "checked": ""} onChange={onChange('attr', true)} disabled={inputDisabled} />
                                <label class="form-check-label" htmlFor="franchise">Franchise?</label>
                            </div>}
                            {isAdmin && <div className="form-check ml-3">
                                <input type="checkbox" class="form-check-input" name="isEcommerce" id="ecom" checked={siteForm?.attr?.isEcommerce ? "checked": ""} onChange={onChange('attr', true)} disabled={inputDisabled} />
                                <label class="form-check-label" htmlFor="ecom">Ecommerce?</label>
                            </div>}
                        </div>
                    </div>
                    <div className="form-row">
                        <div class="form-group col-lg-3">
                            <label class="col-form-label">Business Category:</label>
                            <Input type="select" name="businessType" onChange={onChange()} value={siteForm?.attr?.businessType} disabled={inputDisabled}>
                                <option></option>
                                {BUSINESS_CATEGORIES.map(category => <option key={category} value={category}>
                                    {category}
                                </option>)}
                            </Input>
                        </div>
                        <div class="form-group col-lg-2">
                            <label class="col-form-label"># of Locations:</label>
                            <input type="number" class="form-control" name="noOfLocations" value={siteForm?.attr?.noOfLocations} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                        <div class="form-group col-lg-4">
                            <label class="col-form-label">CRM Site URL:</label>
                            <input type="text" class="form-control" name="crmUrl" value={siteForm?.attr?.crmUrl} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                        <div class="form-group col-lg-3">
                            <label class="col-form-label">CRM Site Icon:</label>
                            <input type="file" class="form-control" name="crmImg" onChange={onImageChange} disabled={inputDisabled} />
                        </div>
                    </div>
                    {/* <div className="form-row">
                        {isAdmin && <div class="form-group col-xl-4 col-lg-6 col-md-6 col-sm-12">
                            <label class="col-form-label">Keywords:</label>
                            <div class="input-group">
                                <input type="text" class="form-control" aria-label="Keyword" placeholder="Keyword" onChange={(e) =>setState(prev => ({...prev, searchTerm: e.target.value}))} value={state.searchTerm} />
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <button type="button" class="btn btn-sm btn-primary" style={{height: "25px"}} onClick={() => addSearchTerm()}>
                                            <i className="fa fa-plus"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>}
                    </div> */}
                </form>
                {isAdmin && <div>
                    {siteForm?.attr?.searchTerms && siteForm?.attr?.searchTerms.map((term, key) => <h4 className="d-inline mr-2">
                        <span class="badge badge-info mb-2">{term} <a href="javascript:;" onClick={() => removeSearchTerm(key)}><i class="fas fa-times"></i></a></span>
                    </h4>)}
                </div>}
                <label class="label-heading">Services</label>
                
                {siteForm?.siteId ? <div className="row justify-content-center">
                    {Object.values(serviceMap).map(service => <div className="col-6 col-sm-4 col-md-4 col-xl-3 text-center mb-4">
                        <ServiceCard 
                            {...service} 
                            onChosen={() => viewService(service)} 
                            refreshRequired={siteForm?.attr?.accounts && siteForm?.attr?.accounts[service.key] && siteForm?.attr?.accounts[service.key].refreshRequired}
                            claimed={siteForm?.attr?.accounts && siteForm?.attr?.accounts[service.key] && site?.attr?.accounts && site?.attr?.accounts[service.key]}
                            overrideIcon={service.key === "gmb" && 
                                ["FAILED", "NOT_FOUND"].includes(siteForm?.attr?.accounts?.gmb?.verificationStatus) ? 
                                <i className={`fas fa-exclamation-circle text-warning fa-1-5`}></i> : 
                                service.key === "ga" && 
                                !siteForm?.attr?.accounts?.ga?.refreshRequired &&
                                siteForm?.attr?.accounts?.ga?.tokenId && 
                                !siteForm?.attr?.accounts?.ga?.tokenId.includes("ga4:") ?
                                <i class="fas fa-sync-alt text-info fa-1-5"></i> :
                                null}
                        />
                    </div>)}
                </div> : <p>
                    Please save the site before adding services
                </p>}             
            </div>
        </div>
        <SidePanelToggle  
            showIconOnActive 
            overrideActiveState={state.servicePanel} 
            onClick={() =>setState(prev => ({...prev, servicePanel: false}))}>
            <BaseService initialChosenService={state.chosenService} />
        </SidePanelToggle>

        <SidePanelToggle className="siteUsers" autoCloseOnBlur overrideActiveState={state.userServicePanel} showIconOnActive onClick={() =>setState(prev => ({...prev, userServicePanel: false}))}>
            <SiteUsers />
        </SidePanelToggle>

        <SidePanelToggle autoCloseOnBlur overrideActiveState={state.refServicePanel} showIconOnActive onClick={() =>setState(prev => ({...prev, refServicePanel: false}))}>
            <ConsumerSources />
        </SidePanelToggle>

        <SidePanelToggle autoCloseOnBlur overrideActiveState={state.refBudgetPanel} showIconOnActive onClick={() =>setState(prev => ({...prev, refBudgetPanel: false}))}>
            <BudgetsAndThresholds />
        </SidePanelToggle>

        <SidePanelToggle id="franchescaAssessmentSidebar" autoCloseOnBlur overrideActiveState={state.refFranchescaAssessmentPanel} showIconOnActive onClick={() => setState(prev => ({...prev, refFranchescaAssessmentPanel: false}))}>
            <FranchescaAssessments />
        </SidePanelToggle>
    </>
}

export default SiteModification